import { phoneIsValid } from '@utils/functions';
import MainButton from '@ui-kit/components/mainButton';
import firebase from 'firebase';
import React, { useRef, useState } from 'react';
import { container } from 'tsyringe';
import styles from '../styles/phoneVerification.module.scss';
import { IModalProvider } from '@base/features/modal/model/interfaces';

export default function PhoneVerification(props: {
  title: string;
  phone?: string;
  onVerified?: (token: string) => void;
  onError?: (error: Error) => void;
}) {
  const modalProvider: IModalProvider = container.resolve('modalProvider');
  const [loading, setLoading] = useState(false);
  const captchaRef = useRef(null);
  const [confirmationResult, setConfirmationResult] = useState<firebase.auth.ConfirmationResult>();

  async function sendSMS(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    if (!props.phone) return;
    try {
      setLoading(true);
      console.log(props.phone);
      const confirmationResult = await firebase.auth().signInWithPhoneNumber(
        `+${props.phone}`,
        new firebase.auth.RecaptchaVerifier(captchaRef.current, {
          size: 'invisible',
          'expired-callback': () => {
            modalProvider.show({
              buttons: [{ title: 'OK', onClick: () => modalProvider.hide() }],
              title: 'Error',
              body: 'Error resolving capcha. Please try again.',
            });
          },
        })
      );
      setConfirmationResult(confirmationResult);
    } catch (e: any) {
      props.onError?.(e);
    } finally {
      setLoading(false);
    }
  }

  async function verifyCode(e: React.ChangeEvent<HTMLInputElement>) {
    if (!confirmationResult || !props.onVerified) return;
    try {
      const verificationCode = e.target.value;
      if (verificationCode.length === 6) {
        await confirmationResult.confirm(verificationCode);
        props.onVerified(confirmationResult.verificationId);
        setConfirmationResult(undefined);
      }
    } catch (e: any) {
      props.onError?.(e);
    }
  }

  return (
    <div className={styles.phoneVerification}>
      {confirmationResult && <input onChange={verifyCode} placeholder="code" />}
      <MainButton
        disabled={!(props.phone && phoneIsValid(props.phone))}
        ref={captchaRef}
        onClick={sendSMS}
        loading={loading}
      >
        {confirmationResult ? 'Resend' : props.title}
      </MainButton>
    </div>
  );
}
